import { Unit } from "uom";
export function volumeByDuration(name, left, right) {
    return Unit.divide(name, "VolumeFlow", left, right);
}
export function volumeFlowBySquareRootPressure(name, left, right) {
    return Unit.divide(name, "VolumeFlowPerSquareRootPressure", left, right);
}
export function lengthByDuration(name, left, right) {
    return Unit.divide(name, "Velocity", left, right);
}
export function velocityBySecond(name, left, right) {
    return Unit.divide(name, "Acceleration", left, right);
}
export function amountOfSubstanceByDuration(name, left, right) {
    return Unit.divide(name, "CatalyticActivity", left, right);
}
export function massByVolume(name, left, right) {
    return Unit.divide(name, "Density", left, right);
}
export function electricChargeByElectricPotential(name, left, right) {
    return Unit.divide(name, "ElectricCapacitance", left, right);
}
export function energyByDuration(name, left, right) {
    return Unit.divide(name, "Power", left, right);
}
export function powerByElectricalCurrent(name, left, right) {
    return Unit.divide(name, "ElectricPotential", left, right);
}
export function electricalCurrentByElectricalPotential(name, left, right) {
    return Unit.divide(name, "ElectricConductance", left, right);
}
export function magneticFluxByElectricalCurrent(name, left, right) {
    return Unit.divide(name, "ElectricInductance", left, right);
}
export function electricalPotentialByElectricalCurrent(name, left, right) {
    return Unit.divide(name, "ElectricResistance", left, right);
}
export function dimentionlessByDuration(name, left, right) {
    return Unit.divide(name, "Frequency", left, right);
}
export function luminousFluxByArea(name, left, right) {
    return Unit.divide(name, "Illuminance", left, right);
}
export function magneticFluxByArea(name, left, right) {
    return Unit.divide(name, "MagneticFluxDensity", left, right);
}
export function massByDuration(name, left, right) {
    return Unit.divide(name, "MassFlow", left, right);
}
export function forceByArea(name, left, right) {
    return Unit.divide(name, "Pressure", left, right);
}
export function energyByMass(name, left, right) {
    return Unit.divide(name, "SpecificEnthalpy", left, right);
}
export function powerByVolumeFlow(name, left, right) {
    return Unit.divide(name, "SpecificFanPower", left, right);
}
export function powerByTemperature(name, left, right) {
    return Unit.divide(name, "HeatCapacityRate", left, right);
}
export function massByMass(name, left, right) {
    return Unit.divide(name, "HumidityRatio", left, right);
}
export function dimensionlessByVolume(name, left, right) {
    return Unit.divide(name, "DimensionlessPerVolume", left, right);
}
export function dimensionlessByEnergy(name, left, right) {
    return Unit.divide(name, "DimensionlessPerEnergy", left, right);
}
export function dimensionlessByDuration(name, left, right) {
    return Unit.divide(name, "DimensionlessPerDuration", left, right);
}
export function powerByArea(name, left, right) {
    return Unit.divide(name, "Intensity", left, right);
}
export function volumeByEnergy(name, left, right) {
    return Unit.divide(name, "WaterUseEfficiency", left, right);
}
export function massByEnergy(name, left, right) {
    return Unit.divide(name, "Emission", left, right);
}
export function massByMolarMass(name, left, right) {
    return Unit.divide(name, "MolarMass", left, right);
}
export function massFlowByArea(name, left, right) {
    return Unit.divide(name, "MassFlowPerArea", left, right);
}
export function energyByVolume(name, left, right) {
    return Unit.divide(name, "HeatingValue", left, right);
}
export function volumeFlowByPower(name, left, right) {
    return Unit.divide(name, "VolumeFlowPerPower", left, right);
}
export function volumeFlowByArea(name, left, right) {
    return Unit.divide(name, "VolumeFlowPerArea", left, right);
}
export function dimensionlessByMass(name, left, right) {
    return Unit.divide(name, "DimensionlessPerMass", left, right);
}
export function powerByDeltaTemperature(name, left, right) {
    return Unit.divide(name, "HeatCapacityRate", left, right);
}
export function intensityByDeltaTemperature(name, left, right) {
    return Unit.divide(name, "ThermalTransmittance", left, right);
}
export function heatCapacityRateByLength(name, left, right) {
    return Unit.divide(name, "ThermalConductivity", left, right);
}
//# sourceMappingURL=unit-divide.js.map